import store from "assets/js/store";
import { getUrlQueryParam, getUtmCookies } from "utils/urlUtils";
import posthog from "posthog-js";
import { amIImpersonating } from "../utils/apiUtils";


const SEGMENT_EVENTS = {
	PAGE: "Page",
	IDENTIFY: "Identify",
	GROUP: "Group",

	SIGN_IN: "User.Loggedin",
	IMPERSONATE: "User.Impersonated",
	SIGN_OUT: "User.Loggedout",

	USER_CREATED: "User.Created",
	USER_UPDATED: "User.Updated",
	USER_DELETED: "User.Deleted",
	USER_CONFIRMED: "User.Confirmed",
	USER_CONFIRMATION_SENT: "User.Confirmation.Sent",
	USER_PASSWORD_RESET: "User.Password.Reset",
	USER_PASSWORD_CONFIRM: "User.Password.Confirm",

	ACCOUNT_CREATED: "Account.Created",
	ACCOUNT_CONFIRMED: "Account.Confirmed",
	ACCOUNT_UPDATED: "Account.Updated",
	ACCOUNT_SETUP: "Account.Setup",
	ACCOUNT_SETUP_FORM: "Account.Setup.Form",
	ACCOUNT_SUSPENDED: "Account.Suspended",
	ACCOUNT_CONVERTED_ORGANIZATION: "Account.Converted.Organization",

	PLAN_DOWNGRADE_INITIATED: "Plan.Upgrade.Initiated",
	PLAN_UPGRADE_INITIATED: "Plan.Downgrade.Initiated",

	CAMPAIGN_CREATED: "Campaign.Created",
	CAMPAIGN_UPDATED: "Campaign.Updated",
	CAMPAIGN_SCHEDULED: "Campaign.Scheduled",
	CAMPAIGN_UNSCHEDULED: "Campaign.Unscheduled",
	CAMPAIGN_DELETED: "Campaign.Deleted",
	CAMPAIGN_DUPLICATED: "Campaign.Duplicated",
	CAMPAIGN_PAUSED: "Campaign.Paused",
	CAMPAIGN_CANCELED: "Campaign.Canceled",
	CAMPAIGN_RESUMED: "Campaign.Resumed",
	CAMPAIGN_SUSPENDED: "Campaign.Suspended",
	TEST_EMAIL_SENT: "Campaign.Test.Sent",
	TEST_EMAIL_SENT_AUTOMATION: "Automation.Test.Sent",
	CAMPAIGN_LOG_EXPORT: "CampaignLog.Export",
	CAMPAIGN_LOG_DOWNLOAD: "CampaignLog.Export.Download",
	CAMPAIGNS_REPORTS_EXPORT: "CampaignsReports.Export",
	CAMPAIGNS_REPORTS_EXPORT_DOWNLOAD: "CampaignsReports.Download",

	TRANSACTIONAL_EMAIL_CREATED: "TransactionalEmail.Created",
	TRANSACTIONAL_EMAIL_UPDATED: "TransactionalEmail.Updated",
	TRANSACTIONAL_EMAIL_DELETED: "TransactionalEmail.Deleted",
	TRANSACTIONAL_EMAIL_DUPLICATED: "TransactionalEmail.Duplicated",
	TRANSACTIONAL_TEST_EMAIL_SENT: "TransactionalEmail.Test.Sent",

	CONTACT_CREATED: "Contact.Created",
	CONTACT_UPDATED: "Contact.Updated",
	CONTACT_DELETED: "Contact.Deleted",
	CONTACT_UNSUBSCRIBED: "Contact.Unsubscribed",
	CONTACT_SUPPRESSED: "Contact.Suppressed",
	CONTACT_UNSUPPRESSED: "Contact.Unsuppressed",
	SUPPRESSED_EMAIL_EXPORT: "SuppressedEmailsReport.Export",
	SUPPRESSED_EMAIL_EXPORT_DOWNLOAD: "SuppressedEmailsReport.Download",
	CONTACT_IMPORTED: "Contact.Imported",
	CONTACT_EXPORT: "Contact.Export",
	CONTACT_EXPORT_DOWNLOAD: "Contact.Export.Download",
	CONTACT_TAGGED: "Contact.Tagged",
	CONTACT_UNTAGGED: "Contact.Untagged",
	CONTACT_INTERESTED: "Contact.Interested",
	CONTACT_UNINTERESTED: "Contact.Uninterested",

	LIST_CREATED: "List.Created",
	LIST_UPDATED: "List.Updated",
	LIST_DELETED: "List.Deleted",
	LIST_LOGS_EXPORT_CREATED: "ListLogsExport.Created",

	SENDER_CREATED: "Sender.Created",
	SENDER_UPDATED: "Sender.Updated",
	SENDER_DELETED: "Sender.Deleted",
	SENDER_CONFIRMED: "Sender.Confirmed",
	SENDER_CONFIRMATION_SENT: "Sender.Confirmation.Sent",

	TEMPLATE_CREATED: "Template.Created",
	TEMPLATE_UPDATED: "Template.Updated",
	TEMPLATE_DELETED: "Template.Deleted",
	TEMPLATE_DUPLICATED: "Template.Duplicated",

	FORM_CREATED: "Form.Created",
	FORM_UPDATED: "Form.Updated",
	FORM_DELETED: "Form.Deleted",

	AUTOMATION_CREATED: "Automation.Created",
	AUTOMATION_UPDATED: "Automation.Updated",
	AUTOMATION_DELETED: "Automation.Deleted",
	AUTOMATION_ACTIVATED: "Automation.Activated",
	AUTOMATION_DEACTIVATED: "Automation.Deactivated",
	AUTOMATION_TRIGGER_ADDED: "Automation.Trigger.Added",
	AUTOMATION_TRIGGER_DELETED: "Automation.Trigger.Deleted",
	AUTOMATION_ACTION_ADDED: "Automation.Action.Added",
	AUTOMATION_ACTION_DELETED: "Automation.Action.Deleted",
	AUTOMATION_CONDITION_ADDED: "Automation.Condition.Added",
	AUTOMATION_CONDITION_DELETED: "Automation.Action.Deleted",
	AUTOMATION_UPGRADE_CLICKED: "Automation.Upgrade.Clicked",
	AUTOMATION_MANUAL_TRIGGER_CLICKED: "Automation.Trigger.Manual.Clicked",
	AUTOMATION_MANUAL_ADD_CONTACTS_CLICKED:
		"Automation.Manual.AddContacts.Clicked",
	AUTOMATION_ACTION_CREATED: "Automation.Action.Created",
	AUTOMATION_ACTION_UPDATED: "Automation.Action.Updated",
	AUTOMATION_INTERACTION_OVERVIEW: "Automation.Interaction.Overview.Viewed",
	AUTOMATION_INTERACTION_CAMPAIGN_REPORT: "Automation.Interaction.Report.Viewed",

	SEGMENT_CREATED: "Segment.Created",
	SEGMENT_UPDATED: "Segment.Updated",
	SEGMENT_DELETED: "Segment.Deleted",

	ACTION_BLOCKED: "Action.Blocked",

	BRAND_UPDATED: "Brand.Updated",

	BRAND_REPO: "BrandRepo.Redirection",
	BRAND_REPO_CANCELLED: "BrandRepo.Dialog.Cancelled",

	SUPPORT_REQUESTED: "Support.Requested",
	SUPPORT_SIGNED_IN: "Support.Signed.In",

	TAG_CREATED: "Tag.Created",
	TAG_UPDATED: "Tag.Updated",
	TAG_DELETED: "Tag.Deleted",

	INTEREST_CREATED: "Interest.Created",
	INTEREST_UPDATED: "Interest.Updated",
	INTEREST_DELETED: "Interest.Deleted",

	PREFERENCE_CENTER_CREATED: "PreferenceCenter.Created",
	PREFERENCE_CENTER_UPDATED: "PreferenceCenter.Updated",

	AI_SUBJECT_GENERATED: "Ai.Subject.Generated",

	BUTTON_CLICKED: "Button.Clicked",
	LINK_CLICKED: "Link.Clicked",
	DROPDOWN_CLICKED: "Dropdown.Clicked",
	DROPDOWN_OPTION_SELECTED: "Dropdown.Option.Clicked",

	MFA_ACTIVATION_FLOW: "MFA.Activation.Flow.Started",
	MFA_DISABLE_FLOW: "MFA.Disable.Flow.Started",
	MFA_ENABLED: "MFA.Enabled",
	MFA_DISABLED: "MFA.Disabled",

	PROFESSIONAL_SERVICES_REQUESTED: "ProfessionalServices.Requested",
};

function segmentCondition(type) {
	const segmentDisabledEvent =
		store.getState().brand?.client_config?.segment_config?.disabled_events;

	if (!segmentDisabledEvent?.includes(type) && posthog?.__loaded) {
		return true;
	}

	return false;
}

export function hasPHFeatureFlag(flag) {
	if (posthog?.__loaded && posthog.isFeatureEnabled(flag)) {
		return true;
	}
}

export function getPHFeatureFlagPayload(flag) {
	if (posthog?.__loaded) {
		return posthog.getFeatureFlagPayload(flag);
	}
}


function trackSegmentEvent(type, data) {
	if (segmentCondition(type)) {
		posthog.capture(type, segmentPayloads(type, data));
	}
}

export function identify(id, data = {}) {
	if (segmentCondition(SEGMENT_EVENTS.IDENTIFY)) {
		posthog.identify(
			cleanPostHogId(id),
			segmentPayloads(SEGMENT_EVENTS.IDENTIFY, data)
		);
	}
}

export function analyticsLogout() {
	if (posthog?.__loaded) {
		posthog.reset();
	}
}

const segmentPayloads = (event, data = null) => {
	let payload = {};

	switch (event) {
		case SEGMENT_EVENTS.PAGE:
			payload = {
				...data
			};
			break;
		case SEGMENT_EVENTS.IMPERSONATE:
		case SEGMENT_EVENTS.SIGN_IN:
		case SEGMENT_EVENTS.SIGN_OUT:
			payload = user(data);
			break;
		case SEGMENT_EVENTS.IDENTIFY:
			if (data?.limitAndUsage || data?.stats) {
				payload = {
					...user(data),
					customer: {
						planType: data?.planType
					},
					account: account(data?.account),
					industryClassification: data?.industryClassification
				};
			} else {
				payload = user(data);

				if (data?.account) {
					payload.account = account(data?.account);
				}
				if (data?.industryClassification) {
					payload.industryClassification = data?.industryClassification;
				}
			}

			if (event === SEGMENT_EVENTS.IDENTIFY) {
				delete payload.url;
			}

			break;
		case SEGMENT_EVENTS.USER_CREATED:
		case SEGMENT_EVENTS.USER_UPDATED:
		case SEGMENT_EVENTS.USER_DELETED:
		case SEGMENT_EVENTS.USER_CONFIRMED:
		case SEGMENT_EVENTS.USER_CONFIRMATION_SENT:
		case SEGMENT_EVENTS.USER_PASSWORD_RESET:
			if (data?.limitAndUsage || data?.stats) {
				payload = {
					...user(data),
					account_id: data?.accountId,
					lineage: data?.lineage,
					stats: data?.stats,
				};
			} else {
				payload = user(data);
			}

			if (event === SEGMENT_EVENTS.IDENTIFY) {
				delete payload.url;
			}

			break;
		case SEGMENT_EVENTS.ACCOUNT_SETUP:
			payload = account(data);
			break;
		case SEGMENT_EVENTS.GROUP:
			payload = { ...account(data), group_type: "Organization", industryClassification: data?.industryClassification };
			break;
		case SEGMENT_EVENTS.ACCOUNT_CREATED:
			payload = {
				temp_id: data?.tempId,
				email: data?.email,
				language: data?.language,
				//Template onboarding only
				account_id: data?.accountId,
			};
			break;
		case SEGMENT_EVENTS.ACCOUNT_CONFIRMED:
			payload = {
				user_id: data?.account_owner?.user_id,
				account_id: data?.id,
				lineage: data?.lineage,
				//Template onboarding only
				campaign_id: data?.campaign_id,
			};
			break;
		case SEGMENT_EVENTS.CAMPAIGN_CREATED:
		case SEGMENT_EVENTS.CAMPAIGN_UPDATED:
		case SEGMENT_EVENTS.CAMPAIGN_SCHEDULED:
		case SEGMENT_EVENTS.CAMPAIGN_UNSCHEDULED:
		case SEGMENT_EVENTS.CAMPAIGN_SUSPENDED:
		case SEGMENT_EVENTS.CAMPAIGN_RESUMED:
		case SEGMENT_EVENTS.CAMPAIGN_CANCELED:
		case SEGMENT_EVENTS.CAMPAIGN_DELETED:
		case SEGMENT_EVENTS.CAMPAIGN_PAUSED:
			payload = campaign(data);
			break;
		case SEGMENT_EVENTS.CAMPAIGN_DUPLICATED:
			payload = {
				duplicated_from_id: data?.duplicatedFromId,
			};
			break;
		case SEGMENT_EVENTS.TRANSACTIONAL_TEST_EMAIL_SENT:
			payload = {
				...transactionalEmail(data),
				emails: data?.emails,
			};
			break;
		case SEGMENT_EVENTS.TEST_EMAIL_SENT:
			payload = {
				...campaign(data),
				emails: data?.emails,
			};
			break;
		case SEGMENT_EVENTS.TEST_EMAIL_SENT_AUTOMATION:
			payload = {
				...workflow(data),
				emails: data?.emails,
			};
			break;
		case SEGMENT_EVENTS.CONTACT_DELETED:
		case SEGMENT_EVENTS.CONTACT_CREATED:
		case SEGMENT_EVENTS.CONTACT_UPDATED:
		case SEGMENT_EVENTS.CONTACT_SUPPRESSED:
		case SEGMENT_EVENTS.CONTACT_UNSUPPRESSED:
		case SEGMENT_EVENTS.CONTACT_UNSUBSCRIBED:
			payload = contact(data);
			break;
		case SEGMENT_EVENTS.CONTACT_IMPORTED:
			payload = {
				list_id: data?.listId,
				contacts_total: data?.contactsTotal,
				contact_imported: data?.contactImported,
				error_count: data?.errorCount,
			};
			break;

		case SEGMENT_EVENTS.LIST_CREATED:
		case SEGMENT_EVENTS.LIST_DELETED:
		case SEGMENT_EVENTS.LIST_UPDATED:
			payload = list(data);
			break;

		case SEGMENT_EVENTS.SENDER_CREATED:
		case SEGMENT_EVENTS.SENDER_UPDATED:
		case SEGMENT_EVENTS.SENDER_DELETED:
		case SEGMENT_EVENTS.SENDER_CONFIRMED:
		case SEGMENT_EVENTS.SENDER_CONFIRMATION_SENT:
			payload = sender(data);
			break;

		case SEGMENT_EVENTS.ACCOUNT_UPDATED:
			payload = {};
			break;

		case SEGMENT_EVENTS.TEMPLATE_CREATED:
		case SEGMENT_EVENTS.TEMPLATE_UPDATED:
		case SEGMENT_EVENTS.TEMPLATE_DELETED:
			payload = template(data);
			break;
		case SEGMENT_EVENTS.TEMPLATE_DUPLICATED:
			payload = {
				name: data?.name,
				duplicated_from_id: data?.duplicatedFromId,
				smart_template: data?.smartTemplate
			};
			break;

		case SEGMENT_EVENTS.FORM_CREATED:
		case SEGMENT_EVENTS.FORM_DELETED:
		case SEGMENT_EVENTS.FORM_UPDATED:
			payload = form(data);
			break;

		case SEGMENT_EVENTS.AUTOMATION_CREATED:
		case SEGMENT_EVENTS.AUTOMATION_UPDATED:
		case SEGMENT_EVENTS.AUTOMATION_DELETED:
		case SEGMENT_EVENTS.AUTOMATION_ACTIVATED:
		case SEGMENT_EVENTS.AUTOMATION_DEACTIVATED:
			payload = workflow(data);
			break;

		case SEGMENT_EVENTS.AUTOMATION_ACTION_CREATED:
		case SEGMENT_EVENTS.AUTOMATION_ACTION_UPDATED:
		case SEGMENT_EVENTS.AUTOMATION_ACTION_DELETED:
			payload = action(data);
			break;

		case SEGMENT_EVENTS.SEGMENT_CREATED:
		case SEGMENT_EVENTS.SEGMENT_UPDATED:
		case SEGMENT_EVENTS.SEGMENT_DELETED:
			payload = segment(data);
			break;

		case SEGMENT_EVENTS.AUTOMATION_INTERACTION_OVERVIEW:
			payload = {
				...workflow(data)
			};
			break;

		case SEGMENT_EVENTS.CONTACT_EXPORT:
		case SEGMENT_EVENTS.CONTACT_EXPORT_DOWNLOAD:
			payload = contactExport(data);
			break;
		case SEGMENT_EVENTS.TAG_CREATED:
		case SEGMENT_EVENTS.TAG_UPDATED:
		case SEGMENT_EVENTS.TAG_DELETED:
		case SEGMENT_EVENTS.CONTACT_TAGGED:
		case SEGMENT_EVENTS.CONTACT_UNTAGGED:
			payload = tags(data);
			break;
		case SEGMENT_EVENTS.INTEREST_CREATED:
		case SEGMENT_EVENTS.INTEREST_DELETED:
		case SEGMENT_EVENTS.INTEREST_UPDATED:
		case SEGMENT_EVENTS.CONTACT_INTERESTED:
		case SEGMENT_EVENTS.CONTACT_UNINTERESTED:
			payload = interests(data);
			break;
		case SEGMENT_EVENTS.PREFERENCE_CENTER_CREATED:
		case SEGMENT_EVENTS.PREFERENCE_CENTER_UPDATED:
			payload = preferenceCenter(data);
			break;

		case SEGMENT_EVENTS.BUTTON_CLICKED:
		case SEGMENT_EVENTS.LINK_CLICKED:
		case SEGMENT_EVENTS.DROPDOWN_CLICKED:
		case SEGMENT_EVENTS.DROPDOWN_OPTION_SELECTED:
			payload = userAction(data);
			break;
		case SEGMENT_EVENTS.AI_SUBJECT_GENERATED:
			payload = aiGeneration(data);
			break;

		case SEGMENT_EVENTS.TRANSACTIONAL_EMAIL_CREATED:
		case SEGMENT_EVENTS.TRANSACTIONAL_EMAIL_UPDATED:
		case SEGMENT_EVENTS.TRANSACTIONAL_EMAIL_DELETED:
			payload = transactionalEmail(data);
			break;
		default:
			payload = data ? data : {};
			break;
	}

	if (
		![
			SEGMENT_EVENTS.IDENTIFY,
			SEGMENT_EVENTS.GROUP,
			SEGMENT_EVENTS.PAGE,
		].includes(event)
	) {
		payload.url = window.location.href;
		payload.hostname = window.location.hostname;
		payload.user_agent = navigator.userAgent;
		payload["$user-agent"] = navigator.userAgent;
		payload.$useragent = navigator.userAgent;

		let utms = getUtmCookies();
		if (utms.utm_campaign) {
			payload.utm_campaign = utms.utm_campaign;
		}
		if (utms.utm_content) {
			payload.utm_content = utms.utm_content;
		}
		if (utms.utm_medium) {
			payload.utm_medium = utms.utm_medium;
		}
		if (utms.utm_source) {
			payload.utm_source = utms.utm_source;
		}

	}

	payload.event_source = "next-gen app 6";
	return flattenObject(payload);
};

function flattenObject(obj, parentKey = "", result = {}) {
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			let newKey = parentKey ? `${parentKey}_${key}` : key;

			if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
				flattenObject(obj[key], newKey, result);
			} else {
				result[newKey] = obj[key];
			}
		}
	}
	return result;
}

export function initPostHog(config) {
	const removeThirdParty = getUrlQueryParam("s") === "true";
	if (
		config?.phId &&
		config?.enabled &&
		!navigator.userAgent.includes("Prerender") &&
		!posthog?.__loaded &&
		!removeThirdParty &&
		!amIImpersonating()
	) {
		let phId = getUrlQueryParam("phId");
		let bootstrapData = {};
		if (phId && segmentCondition(SEGMENT_EVENTS.IDENTIFY)) {
			bootstrapData.distinctID = decodeURIComponent(phId);
		}

		posthog.init(config.phId, {
			api_host:
				config.phServer || process.env.POSTHOG_SERVER,
			ui_host:
				config.phUiHost || process.env.POSTHOG_UI_HOST,
			//if (["dev","integration","staging"].includes(process.env.ENV)) posthog.debug();
			opt_in_site_apps: true,
			bootstrap: bootstrapData,
			capture_pageview: false,
			rate_limiting: {
				events_per_second: config?.eventsPerSecond || 50,
				events_burst_limit: config?.eventsBurstLimit || 200,
			}
		});
	}

	//posthog.__loaded
}

export function cleanPostHogId(id) {
	let formatedId = id || "";
	/*const split = formatedId.split("@");
	if(split.length > 1){
		formatedId += "@" + split[1].toLowerCase();
	}
	return formatedId;*/
	return formatedId.toLowerCase();
}


/*
============
Some actions in routes wont return all the data, but just the id
Segment will clean the data and remove any UNDEFINED properties
============
 */

function transactionalEmail(data) {
	return {
		id: data?.id,
		name: data?.name,
		created_on: data?.created_on,
		updated_on: data?.updated_on
	};
}

function aiGeneration(data) {
	return {
		generated: data?.generated,
		context: data?.context,
	};
}

function preferenceCenter(data) {
	return {
		list_id: data?.listId,
		created_on: data?.created_on,
		custom_attributes: data?.custom_attributes,
		description: data?.description,
		id: data?.id,
		interests: data?.interests,
		title: data?.title,
		updated_on: data?.updated_on,
	};
}

function interests(data) {
	return {
		interests: data?.interests || data?.name,
		alias: data?.alias,
		description: data?.description,
		usage: data?.usage,
		previous_interest: data?.previousInterest,
		list_id: data?.listId,
		contact_ids: data?.contactIds,
		using_query_filter: data?.usingQueryFilter,
	};
}

function tags(data) {
	return {
		tags: data?.tags || data?.tag,
		previous_tag: data?.previousTag,
		list_id: data?.listId,
		contact_ids: data?.contactIds,
		using_query_filter: data?.usingQueryFilter,
	};
}

function userAction(data) {
	return {
		context: data?.context,
		extended_context: data?.extendedContext,
		redirection: data?.redirection,
		skip_confirmation: data?.skipConfirmation,
	};
}

function segment(data) {
	return {
		id: data?.id,
		name: data?.name,
		campaigns_count: data?.campaigns_count,
		last_used: data?.last_used,
		created_on: data?.created_on,
	};
}

function action(data) {
	return {
		id: data?.id,
		name: data?.name,
		parent_id: data?.parent_id,
		condition: data?.condition,
		delay: data?.delay,
		type: data?.type,
		created_on: data?.created_on,
		updated_on: data?.updated_on,
	};
}

function workflow(data) {
	return {
		id: data?.id,
		name: data?.name,
		goal: data?.goal,
		description: data?.description,
		status: data?.status,
		trigger: data?.trigger,
		audience: data?.audience || data?.listId || data?.list_id,
		created_on: data?.created_on,
		updated_on: data?.updated_on,
		activated_on: data?.activated_on,
		paused: data?.paused,
	};
}

function form(data) {
	return {
		id: data?.id,
		name: data?.name,
		status: data?.status,
		language: data?.language,
		created_on: data?.created_on,
		last_updated_on: data?.last_updated_on,
		redirections: data?.redirections,
		list_id: data?.list_id,
		double_opt_in: data?.double_opt_in,
	};
}

function template(data) {
	return {
		id: data?.id,
		name: data?.name,
		created_on: data?.created_on,
		updated_on: data?.updated_on,
		tags: data?.tags,
		smart_template: data?.tags?.includes("smart") || data?.smartTemplate || false
	};
}

function account(data) {
	return {
		id: data?.id,
		address: {
			city: data?.address?.city,
			country: data?.address?.country,
			postal_code: data?.address?.postal_code,
			state: data?.address?.province,
			street: data?.address?.address1,
		},
		created_at: data?.created_on,
		name: data?.name,
		phone: data?.phone,
		website: data?.website,
		lineage: data?.lineage,
		partner: data?.partner,
		organization: data?.organization
	};
}

function user(data) {
	return {
		created_at: data?.created_on,
		firstname: data?.first_name,
		lastname: data?.last_name,
		email: data?.email,
		id: data?.id,
		title: data?.title,
		phone: data?.mobile_phone,
		language: data?.language,
	};
}

function sender(data) {
	return {
		id: data?.id,
		name: data?.name,
		email: data?.email,
		confirmed: data?.confirmed,
		confirmed_on: data?.confirmed_on,
		language: data?.language,
		last_confirmation_sent_on: data?.last_confirmation_sent_on,
	};
}

function list(data) {
	return {
		id: data?.id,
		name: data?.name,
		language: data?.language,
		created_on: data?.created_on,
		default_sender: data?.default_sender,
		redirections: data?.redirections,
	};
}

function contact(data) {
	return {
		id: data?.id,
		email: data?.email,
		subscribed_on: data?.subscribed_on,
		last_bounce_type: data?.last_bounce_type,
		bounces_count: data?.bounces_count,
	};
}

function campaign(data) {
	return {
		campaign_id: data?.id,
		audience: data?.audience,
		name: data?.name,
		subject: data?.content?.subject,
		scheduled_for: data?.scheduled_for,
		created_on: data?.created_on,
		sender: data?.sender,
		content_type: data?.content?.type,
		template_id: data?.content?.bluePrint?.id,
		//Custom properties to pass
		contacts_count: data?.contactsCount,
		used_smart_compose: data?.usedSmartCompose,
		smart_template: data?.smartTemplate
	};
}

function contactExport(data) {
	return {
		list_id: data?.listId,
		segment_id: data?.segment_id,
		description: data?.description,
	};
}

const onboardingPrefix = "Onboarding_";

export {
	SEGMENT_EVENTS,
	segmentPayloads,
	trackSegmentEvent,
	segmentCondition,
	onboardingPrefix,
};

// curl --data '{"api_key": "7d9a966d6b5994ccb1a179ce5c649401", "events": [{"revenue": 1, "price" : 2, "productId" : "133", "quantity" : 1 ,"user_id": "jonathan+nextgenapp@cakemail.com", "event_type": "Order Completed","user_properties": {"Cohort": "Test A"}, "country": "United States", "ip": "127.0.0.1"}]}' https://api.amplitude.com/2/httpapi
